define('bizzabo/models/Agenda',[
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'backbone',
    'backbone-validation',
    'bizzabo/models/Global',
    'bizzabo/models/SyncedModel',
    'bizzabo/models/Day',
    'bizzabo/models/Days',
    'bizzabo/models/Speaker',
    'bizzabo/models/Speakers',
    'bizzabo/models/Sessions',
    'bizzabo/models/RelationsCollection'
], function(
    BZAPI,
    UTILS,
    Consts,
    Backbone,
    BackboneValidation,
    Global,
    SyncedModel,
    Day,
    Days,
    Speaker,
    Speakers,
    Sessions,
    RelationsCollection
    ) {

    var Agenda = SyncedModel.extend({

        shouldFetch : true, //todo get rid of that, put it in the SyncedModel
        wereSessionsSaved : false, // if true, the user added sessions and saved the agenda successfully at least once
        defaults : {},

        initialize : function() {
            if (!this.has("day")) {
                var newDay = new Day();
                var newDays = new Days();
                newDays.add(newDay);
                this.set({
                    'day' : newDays
                });
            }
            if (!this.has("speaker")) {
                var newSpeakers = new Speakers();
                this.set({
                    'speaker' : newSpeakers
                });
            }
            this.get("speaker").comparator = function(speaker) {
                return speaker.get("first-name");
            };
            if (!this.has("relation-session-speaker")) {
                var newRelations = new RelationsSessionSpeaker();
                this.set({
                    'relation-session-speaker' : newRelations
                });
            }
            // NOTICE the first day is given for type info.
            this.get("relation-session-speaker").initRelation(this.get("day").at(0).get("session"), "session", this.get("speaker"), "speaker");

            this.dayErrors = {};
            this.speakerErrors = {};
            this.listenTo(this.get('day'), 'dayValidated', this.daysValidated);
            this.listenTo(this.get('day'), 'remove', this.removedDay);
            this.listenTo(this.get('speaker'), 'validated', this.speakersValidated);
            this.listenTo(this.get('speaker'), 'remove', this.speakersRemoved);
            this.listenTo(this.get('relation-session-speaker'), 'relation:add relation:remove', this.speakersAddedRemovedToSession);
        },

        numberOfErrors: function() {
            return UTILS.leafCount(this.dayErrors) + UTILS.leafCount(this.speakerErrors);
        },

        triggerAgendaValidated: function() {
            var numberOfErrors = this.numberOfErrors();
            this.trigger('agendaValidated', (numberOfErrors <= 0), this, numberOfErrors);
        },

        trackErrors: function(errorsObject, isValid, cid, errors) {
            if (isValid) {
                cid && errorsObject[cid] && delete errorsObject[cid];
            } else {
                errorsObject[cid] = errors;
            }
        },

        daysValidated : function(isValid, model, errors) {
            this.trackErrors(this.dayErrors, isValid, model.cid, errors);
            this.triggerAgendaValidated();
        },

        updateSessionWithSpeakerValidation: function(session, isValid, cid, errors) {
            this.trackErrors(session.speakerErrors, isValid, cid, errors);
            session.set('invalidSpeaker', !session.get('invalidSpeaker'), {
                silent: true
            }); // Force a validation on invalidSpeaker
        },

        speakersValidated: function(isValid, model, errors) {
            this.trackErrors(this.speakerErrors, isValid, model.cid, errors);
            this.triggerAgendaValidated();

            var allSessions = this.getAllSessions();
            var sessions = this.getSessionsOfSpeaker(model, allSessions);
            _.each(sessions, function(session) {
                this.updateSessionWithSpeakerValidation(session, isValid, model.cid, errors);
            }, this);
        },

        speakersAddedRemovedToSession: function(session, speaker) {
            this.updateSessionWithSpeakerValidation(session, true, speaker.cid);
            this.triggerAgendaValidated();
        },

        removedDay : function(model) {
            this.daysValidated(true, model);
        },

        setupWereSessionsSavedFlag : function(model) {
            var days = model.get("day");
            for (var i = 0; i < days.length; i++) {
                var day = days.at(i);
                var sessions = day.get("session");
                if (sessions.length > 0) {
                    model.wereSessionsSaved = true;
                    break;
                }
            }
        },

        getAgendaWithEditedSpeakers: function() {
            this.get('speaker').each(function(speaker) {
                var shouldUpdate = (speaker.wasEdited || speaker.isNew());
                speaker.set('shouldUpdate', shouldUpdate);
            });
            var agenda = this.toJSON();
            agenda.speaker = _.filter(agenda.speaker, function(speaker) {
                return speaker.shouldUpdate;
            });
            return agenda;
        },

        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getAgenda(model.get('eventId'), function(data) {
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                    model.shouldFetch = false;
                    model.syncEventDatesAndAgendaDays();
                    model.setupWereSessionsSavedFlag(model);
                }, options.error);
            }
            else if (method == 'update') {
                var agenda = model.getAgendaWithEditedSpeakers();
                BZAPI.updateAgenda(model.get('eventId'), agenda, function(data) {
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                    model.shouldFetch = false;
                    model.syncEventDatesAndAgendaDays();
                    model.setupWereSessionsSavedFlag(model);
                }, options.error);
            } else if (method == 'create') {
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : "Agenda was not saved, save the event details first!",
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.TIP,
                    autoHide : true
                });
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Failed to save agenda- unsaved event details'
                });
            }
        },

        parse : function(response) {
            this.assimilateJson(response);
            return this.attributes;
        },

        syncEventDatesAndAgendaDays : function() {
            var thisEventId = this.get("eventId");
            var thisEvent = Global.modelPool.getEvent(thisEventId);
            var eventNumberOfDays = thisEvent.numberOfDays();
            var agendaNumberOfDays = this.get("day").length;
            var diff = eventNumberOfDays - agendaNumberOfDays;
            if (diff > 0) {
                this.addDays(diff);
            } else if (diff < 0) {
                this.removeDays(diff * (-1));
            }
        },

        validation : {
            speaker : {
                fn : function(value) {
                    //todo
                }
            },
            day : {
                fn : function(value) {
                    //todo
                }
            }
        },

        getSessionsOfSpeaker : function(speaker, sessions) {
            return this.get("relation-session-speaker").joinByIdOrCid(speaker, sessions);
        },

        getSpeakersForSession : function(session) {
            return this.get("relation-session-speaker").joinByIdOrCid(session);
        },

        isNew : function() {
            return this.get('eventId') == 'new';
        },

        addDays : function(numberOfDaysToAdd) {
            var currentNumberOfDays = this.get("day").length;
            for (var i = 0; i < numberOfDaysToAdd; i++) {
                var newDay = new Day({
                    index : i + currentNumberOfDays
                });
                this.get("day").add(newDay);
            }
        },

        removeDays : function(numberOfDaysToRemove) {
            var thisDays = this.get('day');
            var thisSessionSpeakerRelation = this.get("relation-session-speaker");
            var currentNumberOfDays = thisDays.length;
            var newDayCount = currentNumberOfDays - numberOfDaysToRemove;
            if (newDayCount < 0 || numberOfDaysToRemove <= 0) {
                return;
            }

            var daysToRemove = _.filter(thisDays.models, function(day) {
                return day.get('index') >= newDayCount;
            });
            _.each(daysToRemove, function(day) {
                var sessions = day.get('session');
                sessions.each(function(session) {
                    thisSessionSpeakerRelation.removeAllRelations(session);
                });
                day.destroy();
            });
        },

        validateSessions : function() {
            var err = undefined;
            var days = this.get("day");
            for (var i = 0; i < days.length; i++) {
                var dayErr = days.at(i).validateSessions();
                err = err || dayErr;
            }
            return err;
        },

        validateSpeakers : function() {
            var speakers = this.get('speaker');
            speakers.each(function(speaker) {
                speaker.validate();
            });
        },

        getAllSessions: function() {
            var sessions = new Sessions();
            this.get('day').each(function(day) {
                sessions.add(day.get('session').models, {
                    silent: true
                });
            });
            return sessions;

        },

        getSession: function(idOrCid) {
            return this.getAllSessions().get(idOrCid);
        },

        getMaxTracks: function() {
            var tracksCount = [];
            this.get('day').each(function(day) {
                tracksCount.push(day.get('track').length);
            });
            return _.max(tracksCount);
        }

    });

    var RelationSessionSpeaker = SyncedModel.extend({});
    var RelationsSessionSpeaker = RelationsCollection.extend({
        model : RelationSessionSpeaker
    });

    return Agenda;
});

